var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-footer',{staticClass:"font-weight-medium",attrs:{"dark":"","color":"#707070"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('strong',[_vm._v("Infinite Auto Tech, LLC©")]),_vm._v(" "+_vm._s(new Date().getFullYear())+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }